import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(param) {
    var backgroundColor = param.backgroundColor;
    return {
        base: {
            height: 32,
            width: 1,
            backgroundColor: backgroundColor.neutral.fill.base
        }
    };
};
export var useStyle = function() {
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return {
            dividerStyles: {}
        };
    }
    var base = builtStyle.base;
    return {
        dividerStyles: base
    };
};
